import React, { useEffect, createRef, useState } from 'react'
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { NEW, VIEW, UPDATE } from '../../assets/Constants/actionsTypes'
import { useTranslation } from 'react-i18next';
import './popGroups.css';
import {
    REF_POPULATION_TOTAL,
    REF_POPULATION_LABOUR,
    BEN_UNIT_HOUSEHOLDS,
    BEN_UNIT_INDIVIDUALS
} from './costants';

const PopGroupsModal = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');
    // we create a reference for the modal
    const window = createRef();
    // this variable allow us know if the save button will be shown or not
    const [showSave, setShowSave] = useState(false);
    // if is in UPDATE mode
    const [isUpdate, setIsUpdate] = useState(false);
    // inputs in the modal and its states. Parameters in the api calls
    const [name, setName] = useState('');
    const [beneficaryUnit, setbeneficaryUnit] = useState(BEN_UNIT_HOUSEHOLDS);
    const [initialAgeMale, setInitialAgeMale] = useState('');
    const [finalAgeMale, setFinalAgeMale] = useState('');
    const [initialAgeFemale, setInitialAgeFemale] = useState('');
    const [finalAgeFemale, setFinalAgeFemale] = useState('');
    const [ec1Desc, setEC1Desc] = useState('');
    const [ec2Desc, setEC2Desc] = useState('');
    const [ec3Desc, setEC3Desc] = useState('');
    const [ec1HH, setEC1HH] = useState('');
    const [ec1Y1, setEC1Y1] = useState('');
    const [ec1Y2, setEC1Y2] = useState('');
    const [ec2HH, setEC2HH] = useState('');
    const [ec2Y1, setEC2Y1] = useState('');
    const [ec2Y2, setEC2Y2] = useState('');
    const [ec3HH, setEC3HH] = useState('');
    const [ec3Y1, setEC3Y1] = useState('');
    const [ec3Y2, setEC3Y2] = useState('');
    const [selectedRefPopulation, setSelectedRefPopulation] = useState('totalPopulation');
    const [selectedSex, setSelectedSex] = useState('0');
    /**CONSTANT VARIABLES USED TO FILL UP SELECT ELEMENTS */
    //* Reference Population data
    const REF_POPULATION_DATA = [
        {
            id: REF_POPULATION_TOTAL,
            value: t('popGroups.refPopTotPopulation')
        },
        {
            id: REF_POPULATION_LABOUR,
            value: t('popGroups.refPopLabForce')
        }
    ];

    // here you define the configuration that the modal will have. this depends on the type with which it was opened.
    useEffect(() => {
        if (props.type === NEW) {
            setShowSave(true);
            // Clean and refresh the state of inputs
            setName('');
            setbeneficaryUnit(BEN_UNIT_HOUSEHOLDS);
            setInitialAgeMale('');
            setInitialAgeFemale('');
            setFinalAgeMale('');
            setFinalAgeFemale('');
            setEC1Desc('');
            setEC1HH('');
            setEC1Y1('');
            setEC1Y2('');
            setEC2Desc('');
            setEC2HH('');
            setEC2Y1('');
            setEC2Y2('');
            setEC3Desc('');
            setEC3HH('');
            setEC3Y1('');
            setEC3Y2('');
            setSelectedRefPopulation('totalPopulation');
            setSelectedSex('0');
        } else {
            if (props.data) {
                //* Setting data
                setName(props.data.name);

                setbeneficaryUnit(props.data.beneficiaryUnit);

                setInitialAgeMale(props.data.minAgeMale === null ? '' : props.data.minAgeMale);
                setFinalAgeMale(props.data.maxAgeMale === null ? '' : props.data.maxAgeMale);

                setInitialAgeFemale(props.data.minAgeFemale === null ? '' : props.data.minAgeFemale);
                setFinalAgeFemale(props.data.maxAgeFemale === null ? '' : props.data.maxAgeFemale);

                setSelectedSex(props.data.sexId.toString());
                setSelectedRefPopulation(props.data.refPopId);

                setEC1Desc(props.data.elegibilityCriteria1);
                setEC1HH(props.data.elegibilityCriteria1Y0_HH === null ? '' : props.data.elegibilityCriteria1Y0_HH * 100);
                setEC1Y1(props.data.sexId === 1 ? props.data.elegibilityCriteria1Y0_Female === null ? '' : parseFloat(props.data.elegibilityCriteria1Y0_Female) * 100 : props.data.elegibilityCriteria1Y0_Male === null ? '' : props.data.elegibilityCriteria1Y0_Male * 100);
                setEC1Y2(props.data.elegibilityCriteria1Y0_Female === null ? '' : parseFloat(props.data.elegibilityCriteria1Y0_Female) * 100);

                setEC2Desc(props.data.elegibilityCriteria2 === null ? '' : props.data.elegibilityCriteria2);
                setEC2HH(props.data.elegibilityCriteria2Y0_HH === null ? '' : props.data.elegibilityCriteria2Y0_HH * 100);
                setEC2Y1(props.data.sexId === 1 ? props.data.elegibilityCriteria2Y0_Female === null ? '' : props.data.elegibilityCriteria2Y0_Female * 100 : props.data.elegibilityCriteria2Y0_Male === null ? '' : props.data.elegibilityCriteria2Y0_Male * 100);
                setEC2Y2(props.data.elegibilityCriteria2Y0_Female === null ? '' : props.data.elegibilityCriteria2Y0_Female * 100);

                setEC3Desc(props.data.elegibilityCriteria3 === null ? '' : props.data.elegibilityCriteria3);
                setEC3HH(props.data.elegibilityCriteria3Y0_HH === null ? '' : props.data.elegibilityCriteria3Y0_HH * 100);
                setEC3Y1(props.data.sexId === 1 ? props.data.elegibilityCriteria3Y0_Female === null ? '' : props.data.elegibilityCriteria3Y0_Female * 100 : props.data.elegibilityCriteria3Y0_Male === null ? '' : props.data.elegibilityCriteria3Y0_Male * 100);
                setEC3Y2(props.data.elegibilityCriteria3Y0_Female === null ? '' : props.data.elegibilityCriteria3Y0_Female * 100);

                if (props.type === VIEW) {
                    setShowSave(false)
                } else {
                    if (props.type === UPDATE) {
                        setShowSave(true);
                        setIsUpdate(true);
                    }
                }
            } else {
                props.toggleWindow();
            }
        }

    }, [props])

    // with this we make sure to always hide the maximize and minimize buttons.
    useEffect(() => {
        if (window) {
            hideButtons();
        }
    })

    // with this we hide the maximize and minimize buttons.
    const hideButtons = () => {
        let maximizeButton = window.current.windowElement.querySelector(
            ".k-i-window-maximize"
        ).parentElement;
        maximizeButton.style.visibility = "hidden";

        let minimizeButton = window.current.windowElement.querySelector(
            ".k-i-window-minimize"
        ).parentElement;
        minimizeButton.style.visibility = "hidden";
    }


    const toggleStateEC1 = (e) => {
        if (beneficaryUnit === BEN_UNIT_HOUSEHOLDS) {
            setEC1HH(e.target.value)
            setEC1Y1('')
        } else {
            setEC1HH('')
            setEC1Y1(e.target.value)
        }
    }

    const toggleStateEC2 = (e) => {
        if (beneficaryUnit === BEN_UNIT_HOUSEHOLDS) {
            setEC2HH(e.target.value)
            setEC2Y1('')
        } else {
            setEC2HH('')
            setEC2Y1(e.target.value)
        }
    }

    const toggleStateEC3 = (e) => {
        if (beneficaryUnit === BEN_UNIT_HOUSEHOLDS) {
            setEC3HH(e.target.value)
            setEC3Y1('')
        } else {
            setEC3HH('')
            setEC3Y1(e.target.value)
        }
    }

    return (
        <div className="">
            <Window
                className="ilo-k-window"
                initialHeight={580}
                modal={true}
                title={t('popGroups.modalTitle')}
                resizable={false}
                draggable={false}
                doubleClickStageChange={false}
                onClose={() => {
                    props.toggleWindow();
                }}
                ref={window}
            >
                <div className="container-fluid m-1">
                    {/**Name and Ref. Population row*/}
                    <div className="form-group row">
                        <div className="col-sm-5">
                            <label className="required ilo_lbl_general">{t('popGroups.name_ipt')}</label>
                            <input
                                type="text"
                                // disabled={!showSave || isUpdate}
                                disabled={!showSave}
                                className="form-control ilo-input ilo-modal-input"
                                placeholder={t('popGroups.name_lbl')}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-1">
                            {/**Space between cols*/}
                        </div>
                        <div className="col-sm-6">
                            <label className="ilo_lbl_general">{t('popGroups.refPop_ipt')}</label>
                            <select value={selectedRefPopulation} onChange={(e) => { setSelectedRefPopulation(e.target.value) }} disabled={!showSave} className="form-control ilo-input ilo-modal-input">
                                {REF_POPULATION_DATA.map((population) => {
                                    return (
                                        <option key={population.id} value={population.id}>
                                            {population.value}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                    {/**Beneficiary Unit and Initial Age - Final Age or Average Size row*/}
                    <div className="form-group row">
                        <div className="col-sm-5">
                            <label className="ilo_lbl_general">{t('popGroups.benUnit_ipt')}</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input radio_input"
                                    type="radio" name="popGroupsRadios"
                                    onChange={(e) => { setbeneficaryUnit(e.target.value) }}
                                    value={BEN_UNIT_HOUSEHOLDS}
                                    checked={beneficaryUnit === BEN_UNIT_HOUSEHOLDS}
                                    disabled={!showSave}
                                />
                                <label className="form-check-label radio_label ilo_lbl_general" >{t('popGroups.hoHolds_ipt')}</label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input radio_input"
                                    type="radio" name="popGroupsRadios"
                                    onChange={(e) => { setbeneficaryUnit(e.target.value) }}
                                    value={BEN_UNIT_INDIVIDUALS}
                                    checked={beneficaryUnit === BEN_UNIT_INDIVIDUALS}
                                    disabled={!showSave}
                                />
                                <label className="form-check-label radio_label ilo_lbl_general">{t('popGroups.ind_ipt')}</label>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            {/**Space between cols*/}
                        </div>
                        {beneficaryUnit === BEN_UNIT_HOUSEHOLDS ?
                            <></>
                            :
                            <>
                                <div className="col-sm-5">
                                    <label className="ilo_lbl_general">{t('popGroups.sex_ipt')}</label>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onChange={(e) => { setSelectedSex(e.target.value) }}
                                            value='0'
                                            checked={selectedSex === '0'}
                                            disabled={!showSave}
                                        />
                                        <label className="form-check-label radio_label ilo_lbl_general">{t('modals.sex_m')}</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onChange={(e) => { setSelectedSex(e.target.value) }}
                                            value='1'
                                            checked={selectedSex === '1'}
                                            disabled={!showSave}
                                        />

                                        <label className="form-check-label radio_label ilo_lbl_general">{t('modals.sex_f')}</label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onChange={(e) => { setSelectedSex(e.target.value) }}
                                            value='2'
                                            checked={selectedSex === '2'}
                                            disabled={!showSave}
                                        />
                                        <label className="form-check-label radio_label ilo_lbl_general">{t('modals.sex_b')}</label>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    {/**Sex row*/}
                    {beneficaryUnit === BEN_UNIT_INDIVIDUALS ?
                        <div style={{ backgroundColor: "#D2FBFB", padding: "3px" }}>
                            {/**Sex and Ages titles row*/}
                            <div className="form-group row" style={{ marginBottom: "0px" }}>
                                <div className='col-sm-5 offset-2' style={{ textAlign: "center" }}>
                                    <label className="form-check-label radio_label ilo_lbl_general">{t('popGroups.iniAge_ipt')}</label>
                                </div>
                                <div className='col-sm-5' style={{ textAlign: "center" }}>
                                    <label className="form-check-label radio_label ilo_lbl_general">{t('popGroups.finAge_ipt')}</label>
                                </div>
                            </div>
                            {/**Sex selection row */}
                            <div className="form-group row" style={{ marginBottom: "0px" }}>
                                <div className="col-sm-12">
                                    {selectedSex === '2' ?
                                        <>
                                            <div className="form-group row">
                                                <div className="col-sm-2">
                                                    <label className="form-check-label radio_label ilo_lbl_general">{t('modals.sex_m')}</label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                                        type="text"
                                                        onChange={(e) => { setInitialAgeMale(e.target.value) }}
                                                        placeholder={t('modals.sex_m')}
                                                        disabled={!showSave}
                                                        value={initialAgeMale}
                                                    />
                                                </div>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                                        type="text"
                                                        onChange={(e) => { setFinalAgeMale(e.target.value) }}
                                                        placeholder={t('modals.sex_m')}
                                                        disabled={!showSave}
                                                        value={finalAgeMale}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <div className="col-sm-2">
                                                    <label className="form-check-label radio_label ilo_lbl_general">{t('modals.sex_f')}</label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                                        type="text"
                                                        onChange={(e) => { setInitialAgeFemale(e.target.value) }}
                                                        placeholder={t('modals.sex_f')}
                                                        disabled={!showSave}
                                                        value={initialAgeFemale}
                                                    />
                                                </div>
                                                <div className="col-sm-5">
                                                    <input
                                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                                        type="text"
                                                        onChange={(e) => { setFinalAgeFemale(e.target.value) }}
                                                        placeholder={t('modals.sex_f')}
                                                        disabled={!showSave}
                                                        value={finalAgeFemale}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div className="form-group row">
                                            <div className="col-sm-2">
                                                <label className="form-check-label radio_label ilo_lbl_general">{selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}</label>
                                            </div>
                                            <div className="col-sm-5">
                                                <input
                                                    className="form-control ilo-input ilo-modal-input inputs_right"
                                                    type="text"
                                                    onChange={(e) => { selectedSex === '0' ? setInitialAgeMale(e.target.value) : setInitialAgeFemale(e.target.value) }}
                                                    placeholder={selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}
                                                    disabled={!showSave}
                                                    value={selectedSex === '0' ? initialAgeMale : initialAgeFemale}
                                                />
                                            </div>
                                            <div className="col-sm-5">
                                                <input
                                                    className="form-control ilo-input ilo-modal-input inputs_right"
                                                    type="text"
                                                    onChange={(e) => { selectedSex === '0' ? setFinalAgeMale(e.target.value) : setFinalAgeFemale(e.target.value) }}
                                                    placeholder={selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}
                                                    disabled={!showSave}
                                                    value={selectedSex === '0' ? finalAgeMale : finalAgeFemale}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {/**Elegibility Criteria box*/}
                    <div style={{ marginTop: "20px", backgroundColor: "#D2FBFB", padding: "3px" }}>
                        {/**Elegibility Criteria title row*/}
                        <div className="form-group row" style={{ marginBottom: "0px" }}>
                            <div className={`col-sm-12`}>
                                <label className="form-check-label radio_label ilo_lbl_general" style={{fontWeight: 'bold'}}>{t('popGroups.elg_ipt')}</label>
                            </div>
                        </div>
                        <div className="form-group row" style={{ marginTop: "0px" }}>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '8' : '6'}`}>
                                <span>{t('popGroups.elc_note')}</span>
                            </div>
                            {beneficaryUnit === BEN_UNIT_HOUSEHOLDS ?
                                <>
                                    <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4 ' : '6'}`}>
                                        <label className="form-check-label radio_label ilo_lbl_general">{t('popGroups.ipt_cvg')}</label>
                                    </div>
                                </>
                                :
                                selectedSex === '2' ?
                                    <>
                                        <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4 ' : '3'}`}>
                                            <label className="form-check-label radio_label ilo_lbl_general" style={{ fontSize: "12px" }}>{`${t('popGroups.ipt_cvg')}/${t('modals.sex_m')}`}</label>
                                        </div>
                                        <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4 ' : '3'}`}>
                                            <label className="form-check-label radio_label ilo_lbl_general" style={{ fontSize: "12px" }}>{`${t('popGroups.ipt_cvg')}/${t('modals.sex_f')}`}</label>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4 ' : '6'}`}>
                                            <label className="form-check-label radio_label ilo_lbl_general">{`${t('popGroups.ipt_cvg')}/${selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}`}</label>
                                        </div>
                                    </>
                            }
                        </div>
                        {/**Elegibility Criteria 1 and its year 0 row*/}
                        <div className="form-group row">
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '1' : '1'} numbers_ec`}>
                                <label className="form-check-label radio_label ilo_lbl_general">1.</label>
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '7' : '5'} padding_div`}>
                                <input
                                    className="form-control ilo-input ilo-modal-input"
                                    type="text"
                                    onChange={(e) => { setEC1Desc(e.target.value) }}
                                    placeholder={t('popGroups.dsc_ipt')}
                                    disabled={!showSave}
                                    value={ec1Desc}
                                />
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4' : '3'}`}>
                                <div className="input-group">
                                    <input
                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                        type="text"
                                        onChange={(e) => { toggleStateEC1(e) }}
                                        placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '1' ? t('modals.sex_f') : t('modals.sex_m')}
                                        disabled={!showSave}
                                        value={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? ec1HH : ec1Y1}
                                    />
                                    <div className="input-group-append ilo-input">
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                            {(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ?
                                <></>
                                :
                                <div className="col-sm-3">
                                    <div className="input-group">
                                        <input
                                            className="form-control ilo-input ilo-modal-input inputs_right"
                                            type="text"
                                            onChange={(e) => { setEC1Y2(e.target.value) }}
                                            placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}
                                            disabled={!showSave}
                                            value={ec1Y2}
                                        />
                                        <div className="input-group-append ilo-input">
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {/**Elegibility Criteria 2 and its year 0 row*/}
                        <div className="form-group row">
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '1' : '1'} numbers_ec`}>
                                <label className="form-check-label radio_label ilo_lbl_general">2.</label>
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '7' : '5'} padding_div`}>
                                <input
                                    className="form-control ilo-input ilo-modal-input"
                                    type="text"
                                    onChange={(e) => { setEC2Desc(e.target.value) }}
                                    placeholder={t('popGroups.dsc_ipt')}
                                    disabled={!showSave}
                                    value={ec2Desc}
                                />
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4' : '3'}`}>
                                <div className="input-group">
                                    <input
                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                        type="text"
                                        onChange={(e) => { toggleStateEC2(e) }}
                                        placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '1' ? t('modals.sex_f') : t('modals.sex_m')}
                                        disabled={!showSave}
                                        value={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? ec2HH : ec2Y1}
                                    />
                                    <div className="input-group-append ilo-input">
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                            {(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ?
                                <></>
                                :
                                <div className="col-sm-3">
                                    <div className="input-group">
                                        <input
                                            className="form-control ilo-input ilo-modal-input inputs_right"
                                            type="text"
                                            onChange={(e) => { setEC2Y2(e.target.value) }}
                                            placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}
                                            disabled={!showSave}
                                            value={ec2Y2}
                                        />
                                        <div className="input-group-append ilo-input">
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        {/**Elegibility Criteria 3 and its year 0 row*/}
                        <div className="form-group row">
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '1' : '1'} numbers_ec`}>
                                <label className="form-check-label radio_label ilo_lbl_general">3.</label>
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '7' : '5'} padding_div`}>
                                <input
                                    className="form-control ilo-input ilo-modal-input"
                                    type="text"
                                    onChange={(e) => { setEC3Desc(e.target.value) }}
                                    placeholder={t('popGroups.dsc_ipt')}
                                    disabled={!showSave}
                                    value={ec3Desc}
                                />
                            </div>
                            <div className={`col-sm-${(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ? '4' : '3'}`}>
                                <div className="input-group">
                                    <input
                                        className="form-control ilo-input ilo-modal-input inputs_right"
                                        type="text"
                                        onChange={(e) => { toggleStateEC3(e) }}
                                        placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '1' ? t('modals.sex_f') : t('modals.sex_m')}
                                        disabled={!showSave}
                                        value={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? ec3HH : ec3Y1}
                                    />
                                    <div className="input-group-append ilo-input">
                                        <span className="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                            {(beneficaryUnit === BEN_UNIT_HOUSEHOLDS || selectedSex === '0' || selectedSex === '1') ?
                                <></>
                                :
                                <div className="col-sm-3">
                                    <div className="input-group">
                                        <input
                                            className="form-control ilo-input ilo-modal-input inputs_right"
                                            type="text"
                                            onChange={(e) => { setEC3Y2(e.target.value) }}
                                            placeholder={beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? t('popGroups.y0_ipt') : selectedSex === '0' ? t('modals.sex_m') : t('modals.sex_f')}
                                            disabled={!showSave}
                                            value={ec3Y2}
                                        />
                                        <div className="input-group-append ilo-input">
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <WindowActionsBar layout="end">
                        {showSave &&
                            <button
                                onClick={() => {
                                    const data = {
                                        popGroupId: isUpdate ? props.data.popGroupId : 0,
                                        name,
                                        selectedRefPopulation,
                                        beneficaryUnit,
                                        initialAgeMale: beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? '' : parseInt(initialAgeMale, 10),
                                        finalAgeMale: beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? '' : parseInt(finalAgeMale, 10),
                                        initialAgeFemale: beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? '' : parseInt(initialAgeFemale, 10),
                                        finalAgeFemale: beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? '' : parseInt(finalAgeFemale, 10),
                                        selectedSex: beneficaryUnit === BEN_UNIT_HOUSEHOLDS ? -1 : parseInt(selectedSex, 10),
                                        ec1Desc,
                                        ec1HH: ec1HH === null ? '' : ec1HH,
                                        ec1Y1: ec1Y1 === null ? '' : ec1Y1,
                                        ec1Y2: ec1Y2 === null ? '' : ec1Y2,
                                        ec2Desc,
                                        ec2HH: ec2HH === null ? '' : ec2HH,
                                        ec2Y1: ec2Y1 === null ? '' : ec2Y1,
                                        ec2Y2: ec2Y2 === null ? '' : ec2Y2,
                                        ec3Desc,
                                        ec3HH: ec3HH === null ? '' : ec3HH,
                                        ec3Y1: ec3Y1 === null ? '' : ec3Y1,
                                        ec3Y2: ec3Y2 === null ? '' : ec3Y2
                                    }
                                    props.onSave(data)
                                }}
                                className="btn btn-primary ilo-btn"
                            >
                                {t('modals.save_btn')}
                            </button>
                        }

                        <button onClick={props.toggleWindow} className="btn btn-primary ilo-btn">{showSave ? t('modals.cancel_btn') : t('modals.close_btn')}</button>
                    </WindowActionsBar>
                </div>
            </Window>
        </div>
    );
}

export default PopGroupsModal